import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Header, useModal, toast } from '@ohif/ui-next';
import { SidebarNavigation } from '@ohif/ui';
import { useNavigate } from 'react-router';
import { useAppConfig } from '@state';
import { useTranslation } from 'react-i18next';
import { api } from '../Users/user';

function WLConfiguration({ servicesManager }) {
  const navigate = useNavigate();
  const [appConfig] = useAppConfig();
  const { t } = useTranslation();
  const { show } = useModal();

  const [presets, setPresets] = useState({
    '1': { description: 'Cerebro', window: '', level: '' },
    '2': { description: 'Pulmón', window: '', level: '' },
    '3': { description: 'Hueso', window: '', level: '' },
    '4': { description: 'Abdomen', window: '', level: '' },
  });

  const [isLoading, setIsLoading] = useState(true);

  // Fetch presets on load
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(api + '/api/settings'); // Adjust URL if needed
        if (!response.ok) throw new Error('Failed to fetch settings');
        const data = await response.json();

        if (data.windowLevelPresets && data.windowLevelPresets.CT) {
          setPresets(prev => ({ ...prev, ...data.windowLevelPresets.CT }));
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
        toast.error('Error al cargar la configuración');
      } finally {
        setIsLoading(false);
      }
    };

    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      // First fetch current settings to avoid overwriting other fields
      const getResponse = await fetch(api + '/api/settings');
      const currentSettings = await getResponse.json();

      const updatedSettings = {
        ...currentSettings,
        windowLevelPresets: {
          ...currentSettings.windowLevelPresets,
          CT: presets, // For now we only handle CT
        },
      };

      const response = await fetch(api + '/api/settings', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedSettings),
      });

      if (!response.ok) throw new Error('Failed to update settings');

      toast.success('Configuración guardada exitosamente');
    } catch (error) {
      console.error('Error saving settings:', error);
      toast.error('Error al guardar la configuración');
    }
  };

  const handleChange = (id, field, value) => {
    setPresets(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const menuOptions = [
    {
      title: 'Volver',
      icon: 'arrow-left',
      onClick: () => navigate('/')
    }
  ];

  if (isLoading) {
    return <div className="flex h-screen items-center justify-center text-white">Cargando...</div>;
  }

  return (
    <div className="flex h-full flex-col bg-black">
      <Header
        isSticky
        menuOptions={menuOptions}
        isReturnEnabled={false}
        WhiteLabeling={appConfig.whiteLabeling}
      />

      <SidebarNavigation onFilterToggle={() => navigate('/')} />

      <div className="container mx-auto min-h-screen bg-gray-50 pt-5 text-black p-4 sm:pl-9">
        <h1 className="text-3xl font-bold mb-6">Configuración de Window Level (CT)</h1>

        <div className="bg-white p-6 rounded shadow max-w-4xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {Object.entries(presets).map(([id, preset]) => (
              <div key={id} className="border p-4 rounded bg-gray-50">
                <h3 className="text-lg font-semibold mb-3">{preset.description}</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Window Width</label>
                    <input
                      type="number"
                      value={preset.window}
                      onChange={(e) => handleChange(id, 'window', e.target.value)}
                      className="w-full rounded border border-gray-300 p-2 focus:ring-primary-main focus:border-primary-main"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Window Center (Level)</label>
                    <input
                      type="number"
                      value={preset.level}
                      onChange={(e) => handleChange(id, 'level', e.target.value)}
                      className="w-full rounded border border-gray-300 p-2 focus:ring-primary-main focus:border-primary-main"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex justify-end">
            <button
              onClick={handleSave}
              className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

WLConfiguration.propTypes = {
  servicesManager: PropTypes.object.isRequired,
};

export default WLConfiguration;
